export default "__VITE_ASSET__pK1$fPO0__"